import { enContent } from "@/i18n/content.en";
import type { Messages } from "@/i18n/types";

export const enMessages: Messages = {
  actions: {
    backToHome: "Back to home",
    call: "Call",
    closeMenu: "Close navigation menu",
    consultation: "Inquiry",
    copyLink: "Copy link",
    copyLinkSuccess: "Link copied to clipboard",
    email: "Email",
    openMenu: "Open navigation menu",
    share: "Share",
    switchLanguage: "Change language",
    tryAgain: "Try again",
  },
  admin: {
    emailPlaceholder: "name@example.com",
    emptyDescription:
      "New event inquiries will appear here when visitors submit the public form.",
    emptyTitle: "No inquiries yet",
    eyebrow: "Studio dashboard",
    eventTypeLabel: "Event type",
    filterAllStatuses: "All statuses",
    filterStatusLabel: "Filter by status",
    inquiriesDescription:
      "Review event inquiries, planning needs, and contact details in one place.",
    inquiriesLoadError:
      "The dashboard could not load inquiries right now. Try refreshing the page.",
    inquiriesLoading: "Loading inquiries...",
    inquiriesTitle: "Submitted event inquiries",
    inquiryDetailsTitle: "Inquiry details",
    inquiryListTitle: "Inquiry list",
    inquiryListSupport: "Filter or select an inquiry to review the details.",
    loginButton: "Log in",
    loginDescription: "Use the studio credentials to review event inquiries.",
    loginError: "The email or password is incorrect.",
    loginPending: "Logging in...",
    loginTitle: "Studio login",
    statusArchived: "Archived",
    statusInProgress: "In progress",
    statusLabel: "Status",
    statusNew: "New",
    statusSaveError:
      "The inquiry status could not be updated right now. Try again.",
    statusSavePending: "Saving status...",
    statusSaveSuccess: "Status updated.",
    logoutButton: "Log out",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password",
    receivedAtLabel: "Received",
  },
  common: {
    address: "Address",
    description: "Description",
    email: "Email",
    loading: "Loading…",
    mobileNavigation: "Mobile navigation",
    name: "Name",
    optional: "Optional",
    phone: "Phone",
    primaryNavigation: "Primary navigation",
    required: "Required",
    skipToContent: "Skip to main content",
    toggleNav: "Toggle navigation",
  },
  consent: {
    accept: "Accept analytics",
    decline: "Decline",
    description:
      "We use privacy-friendly analytics to see how visitors use the JPL Atelier website. No cookies and no cross-site tracking.",
    learnMore: "Read the privacy note",
    title: "Help us improve the website",
  },
  errors: {
    boundaryEyebrow: "Unexpected error",
    boundaryHint:
      "Reload the page. If it keeps happening, contact the website team.",
    boundaryTitle: "Something went wrong while loading this page.",
    notFoundIntro:
      "The page you’re looking for may have moved, changed, or never been published.",
    notFoundSeoTitle: "404",
    notFoundTitle: "This page could not be found.",
    unknownLocale: "Unknown language. Defaulting to English.",
  },
  footer: {
    apoloLogoAlt: "Apolo Inventions",
    credit: "Built and managed by Apolo Inventions",
    follow: "Follow",
  },
  localeSwitcher: {
    englishLabel: "EN",
    spanishLabel: "ES",
  },
  share: {
    email: "Share via email",
    linkedin: "Share on LinkedIn",
    native: "Share…",
    twitter: "Share on X",
  },
  sitemap: {
    jumpToSection: "Jump to section",
  },
  content: enContent,
};
